import {
  adminDashboardTabs,
  crewLeaderDashboardTabs,
  crewSupervisorDesignerDashboardTabs
} from "../js-data/dashboard-tab-groups";
import {
  addCrewAssignment,
  getCancelledDeliveries,
  getCrewsScheduledWeekly,
  getDeliveredProcurements,
  getMyTasks,
  getOnHoldDeliveries,
  getScheduledDeliveries,
  getWorkOrders
} from "../api-helpers/api-dashboard";
import moment from "moment";

export default {
  state: {
    adminDashboardTabs: adminDashboardTabs,
    adminDashboardFilters: ["Work", "Deliveries"],
    isGettingScheduledCrews: false,
    scheduledCrews: null,
    scheduledCrewView: null,
    isGettingScheduledDeliveries: false,
    scheduledDeliveries: null,
    isGettingDeliveredProcurements: false,
    deliveredProcurements: null,
    isGettingOnHoldDeliveries: false,
    onHoldDeliveries: null,
    isGettingCancelledDeliveries: false,
    cancelledDeliveries: null,
    isGettingMyTasks: false,
    myTasks: null,
    isGettingWorkOrders: false,
    workOrders: null,
    isAddingCrewAssignment: false,
    crewLeaderTabs: crewLeaderDashboardTabs,
    crewSupervisorDesignerTabs: crewSupervisorDesignerDashboardTabs
  },
  mutations: {
    setAdminDashboardFilters(state, filters) {
      state.adminDashboardFilters = filters;
    },
    setIsGettingScheduledCrews(state, isLoading) {
      state.isGettingScheduledCrews = isLoading;
    },
    setScheduledCrews(state, crews) {
      state.scheduledCrews = crews;
    },
    setIsGettingScheduledDeliveries(state, bool) {
      state.isGettingScheduledDeliveries = bool;
    },
    setScheduledDeliveries(state, procurements) {
      state.scheduledDeliveries = procurements;
    },
    setIsGettingDeliveredProcurements(state, bool) {
      state.isGettingDeliveredProcurements = bool;
    },
    setDeliveredProcurements(state, procurements) {
      state.deliveredProcurements = procurements;
    },
    setIsGettingOnHoldDeliveries(state, bool) {
      state.isgettingOnHoldDeliveries = bool;
    },
    setOnHoldDeliveries(state, procurements) {
      state.onHoldDeliveries = procurements;
    },
    setIsGettingCancelledDeliveries(state, bool) {
      state.isGettingCancelledDeliveries = bool;
    },
    setCancelledDeliveries(state, procurements) {
      state.cancelledDeliveries = procurements;
    },
    setAdminDashboardCounts(state, counts) {
      state.adminDashboardTabs = state.adminDashboardTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    },
    setIsGettingMyTasks(state, bool) {
      state.isGettingMyTasks = bool;
    },
    setMyTasks(state, myTasks) {
      state.myTasks = myTasks;
    },
    setIsGettingWorkOrders(state, bool) {
      state.isGettingWorkOrders = bool;
    },
    setWorkOrders(state, workOrders) {
      state.workOrders = workOrders;
    },
    setIsAddingCrewAssignment(state, bool) {
      state.isAddingCrewAssignment = bool;
    },
    setCrewLeaderTabsCounts(state, counts) {
      state.crewLeaderTabs = state.crewLeaderTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    }
  },
  actions: {
    async getScheduledCrews({ state, dispatch, commit }) {
      let scheduledCrews;
      if (!state.isGettingScheduledCrews) {
        commit("setIsGettingScheduledCrews", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        scheduledCrews = await getCrewsScheduledWeekly(startDate, endDate);
        commit("setScheduledCrews", scheduledCrews);

        commit("setIsGettingScheduledCrews", false);
      }
      return scheduledCrews;
    },
    async getScheduledDeliveries({ state, commit, dispatch }) {
      let scheduledDeliveries;
      if (!state.isGettingScheduledDeliveries) {
        commit("setIsGettingScheduledDeliveries", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        scheduledDeliveries = await getScheduledDeliveries(startDate, endDate);
        commit("setScheduledDeliveries", scheduledDeliveries);

        commit("setIsGettingScheduledDeliveries", false);
      }
      return scheduledDeliveries;
    },
    async getDeliveredProcurements({ state, dispatch, commit }) {
      let deliveredProcurements;
      if (!state.isGettingDeliveredProcurements) {
        commit("setIsGettingDeliveredProcurements", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        deliveredProcurements = await getDeliveredProcurements(
          startDate,
          endDate
        );
        commit("setDeliveredProcurements", deliveredProcurements);

        commit("setIsGettingDeliveredProcurements", false);
      }
      return deliveredProcurements;
    },
    async getOnHoldDeliveries({ state, dispatch, commit }) {
      let onHoldDeliveries;
      if (!state.isGettingOnHoldDeliveries) {
        commit("setIsGettingOnHoldDeliveries", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        onHoldDeliveries = await getOnHoldDeliveries(startDate, endDate);
        commit("setOnHoldDeliveries", onHoldDeliveries);

        commit("setIsGettingOnHoldDeliveries", false);
      }
      return onHoldDeliveries;
    },
    async getCancelledDeliveries({ state, dispatch, commit }) {
      let cancelledDeliveries;
      if (!state.isGettingCancelledDeliveries) {
        commit("setIsGettingCancelledDeliveries", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        cancelledDeliveries = await getCancelledDeliveries(startDate, endDate);
        commit("setCancelledDeliveries", cancelledDeliveries);

        commit("setIsGettingCancelledDeliveries", false);
      }
      return cancelledDeliveries;
    },
    async getMyTasks({ state, dispatch, commit }) {
      let myTasks;
      if (!state.isGettingMyTasks) {
        commit("setIsGettingMyTasks", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        myTasks = await getMyTasks(startDate, endDate);
        commit("setMyTasks", myTasks);

        commit("setIsGettingMyTasks", false);
      }
      return myTasks;
    },
    async getWorkOrders({ state, dispatch, commit }) {
      let workOrders;
      if (!state.isGettingWorkOrders) {
        commit("setIsGettingWorkOrders", true);

        const { startDate, endDate } = await dispatch(
          "getStartAndEndDates"
        ).then(res => res);

        workOrders = await getWorkOrders(startDate, endDate);
        commit("setWorkOrders", workOrders);

        commit("setIsGettingWorkOrders", false);
      }
      return workOrders;
    },
    async addCrewAssignment({ state, dispatch, commit }, formParams) {
      let response;
      if (!state.isAddingCrewAssignment && formParams) {
        commit("setIsAddingCrewAssignment", true);

        response = await addCrewAssignment(formParams);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Crew successfully added to schedule.",
          errorText:
            "An error occurred while attempting to add Crew to schedule.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getScheduledCrews");
          }
        });

        commit("setIsAddingCrewAssignment", false);
      }
      return response;
    }
  },
  getters: {
    selectedWeekDays: (state, getters, rootState) => {
      if (rootState.selectedWeekStartDate) {
        let selectedWeekStartDate = rootState.selectedWeekStartDate.clone();
        let selectedWeekDays = [];

        Array(7)
          .fill()
          .map((_, i) =>
            selectedWeekDays.push(
              moment(selectedWeekStartDate)
                .add(i, "days")
                .format("YYYY-MM-DD 00:00:00")
            )
          );
        return selectedWeekDays;
      } else {
        return false;
      }
    },
    weeklyCrewView: (state, getters) => {
      if (state.scheduledCrews) {
        return state.scheduledCrews.map(crew => {
          const days = getters.selectedWeekDays.reduce((acc, day) => {
            const workScopeItemsForDay = crew.work_scope_items
              .filter(wsi => {
                return (
                  wsi.scheduled_for === day ||
                  wsi.schedules.map(s => s.scheduled_for).indexOf(day) > -1
                );
              })
              .map(wsi => {
                return {
                  ...wsi,
                  name: wsi.work_scope_item.name
                };
              });

            const tasksForDay = crew.tasks.filter(task => {
              return (
                task.scheduled_for === day ||
                task.schedules.map(s => s.scheduled_for).indexOf(day) > -1
              );
            });

            const procurementsForDay = crew.scheduled_procurements.filter(
              proc => {
                return proc.scheduled_for === day;
              }
            );

            let projectItemsObject = {};
            if (state.adminDashboardFilters.indexOf("Work") > -1) {
              projectItemsObject = [
                ...workScopeItemsForDay,
                ...tasksForDay
              ].reduce((acc, item) => {
                if (!acc[item.contract.project_id]) {
                  acc[item.contract.project_id] = {
                    project_id: item.contract.project_id,
                    project_name: item.contract.project_name,
                    contract_id: item.contract.id,
                    contract_name: item.contract.name,
                    primaryContactName: item.contract.primaryContactName,
                    fullAddress: item.contract.place.fullAddress,
                    work_items: [],
                    procurement_items: []
                  };
                }

                acc[item.contract.project_id].work_items.push(item);

                return acc;
              }, {});
            }

            if (state.adminDashboardFilters.indexOf("Deliveries") > -1) {
              procurementsForDay.forEach(proc => {
                if (!projectItemsObject[proc.contract.project_id]) {
                  projectItemsObject[proc.contract.project_id] = {
                    project_id: proc.contract.project_id,
                    project_name: proc.contract.project_name,
                    contract_id: proc.contract.id,
                    contract_name: proc.contract.name,
                    primaryContactName: proc.contract.primaryContactName,
                    fullAddress: proc.contract.place.fullAddress,
                    work_items: [],
                    procurement_items: []
                  };
                }

                projectItemsObject[
                  proc.contract.project_id
                ].procurement_items.push(proc);
              });
            }

            acc[day] = Object.values(projectItemsObject);

            return acc;
          }, {});

          return {
            id: crew.id,
            identifier: crew.identifier,
            days
          };
        });
      }
      return [];
    }
  }
};
